import TWalkthroughSelectIvr from './index.vue';

TWalkthroughSelectIvr.install = app => {
  app.component(TWalkthroughSelectIvr.name, TWalkthroughSelectIvr);
};

export default TWalkthroughSelectIvr;
